<template>
<BaseModal :id="'associate-warning-modal'" :title="`No Associate Selected`" :message="message" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-12" @submit.prevent="proceed()">

            <CentralLiteButtons :save_text="'Proceed anyways'" :cancel_text="'Go back'"/>
        </form>
    </template>
</BaseModal>
</template>

    
    
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import BaseModal from "@/components/BaseModal";

export default {
    name: "AssociateWarningModal",

    props: ["breadcrumb"],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons,
    },

    data() {
        return {
            message: `To ensure clarity during your inspection, please assign an associate to this room, as it is currently being completed without one.`,
        };
    },
    methods: {
        close(event) {
            this.$emit("close", event);
        },
        proceed()
        {
            this.$emit('complete_inspection')
        }

    },

    computed: {},

    mounted() {},
};
</script>
